import { useCallback, useState } from 'react';
import type { CoverDoc } from 'fym-shared/src/music24/coverDoc';
import { exportCoverJpeg } from '../render/exportCoverJpeg';
import { coverExportFileName } from '../render/exportRules';

/** Hands a file to the browser as a download. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // The browser reads the address after the click; the memory goes back a little later.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/**
 * "Download" of the top bar (owner decision D10: a 3000 px JPEG): the browser draws the file with
 * the one renderer and saves it. `watermark` is true for Free and the trial (D7).
 */
export function useDownloadCover(input: { doc: CoverDoc; watermark: boolean; artist: string; title: string }) {
  const { doc, watermark, artist, title } = input;
  const [isBusy, setIsBusy] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const download = useCallback(() => {
    setIsBusy(true);
    setIsFailed(false);
    exportCoverJpeg(doc, { watermark })
      .then(({ blob, side }) => saveBlob(blob, coverExportFileName({ artist, title, side })))
      .catch((error: unknown) => {
        console.error('Cover editor: the download failed', error);
        setIsFailed(true);
      })
      .finally(() => setIsBusy(false));
  }, [artist, doc, title, watermark]);
  return { download, isBusy, isFailed };
}
